import * as React from "react";
import styles from "./incomeGraph.module.css";
import PieIncomeChart from "./PieIncomeChart";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";

const ListDonutWidget = ({ donutGraphData }) => {
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 13,
    },
  }));

  return (
    <>
      {donutGraphData?.totalIcome !== '0.00' && (<><div className={`${styles.ChartMainSec}`}>
        <div className={`${styles.TotalIncomeSec}`}>
          <p className={`${styles.Amount}`}>${donutGraphData?.totalIcome}</p>
          <p className={`${styles.Text}`}>Total Income</p>
          <p className={`${styles.Text2}`}>
            ${donutGraphData?.totalCompleted} Completed
          </p>
          <p className={`${styles.Text2}`}>
            ${donutGraphData?.totalPending} Pending
          </p>
        </div>
        <div className={`${styles.ChartSec}`}>
          <PieIncomeChart categories={donutGraphData?.categories} />
        </div>
      </div>
      <div className={`${styles.ChartListCatMain}`}>
        {donutGraphData &&
          donutGraphData?.categories?.map((c, i) => {
            const total = c?.total || 0;
            const completed = c?.completed || 0;
            const pending = c?.pending || 0;
            const formatedTotal = parseFloat(
              (c?.total || "0").replace(/,/g, "")
            );
            const formatedCompleted = parseFloat(
              (c?.completed || "0").replace(/,/g, "")
            );
            const formatedPending = parseFloat(
              (c?.pending || "0").replace(/,/g, "")
            );
            const completedPercent = total
              ? (formatedCompleted / formatedTotal) * 100
              : 0;
            const pendingPercent = total
              ? (formatedPending / formatedTotal) * 100
              : 0;

            return (
              <div className={styles.ChartListCat} key={i}>
                <p>
                  {c?.title} <span>${total.toLocaleString()}</span>
                </p>
                <div className={styles.ChartProgressTrack}>
                  <BootstrapTooltip
                    title={
                      <div className={styles.IncomeLineTooltip}>
                        <p>Completed: ${completed.toLocaleString()}</p>
                      </div>
                    }
                  >
                    <div
                      style={{
                        width: `${completedPercent}%`,
                        backgroundColor: c?.color,
                        cursor: "pointer",
                      }}
                    ></div>
                  </BootstrapTooltip>
                  <BootstrapTooltip
                    title={
                      <div className={styles.IncomeLineTooltip}>
                        <p>Pending: ${pending.toLocaleString()}</p>
                      </div>
                    }
                  >
                    <div
                      style={{
                        width: `${pendingPercent}%`,
                        backgroundColor: c?.color,
                        cursor: "pointer",
                        filter: 'brightness(0.75)'
                      }}
                    ></div>
                  </BootstrapTooltip>
                </div>
              </div>
            );
          })}
        </div></>)}
      {donutGraphData?.totalIcome === '0.00' &&
        <div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-income.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>No earnings yet</p>
          <p className={`${styles.NoDataTextSub}`}>Start tracking income to unlock insights.</p>
        </div>
      }
    </>
  );
};

export default ListDonutWidget;
